import * as React from "react"

import { PdfSurface } from "./pdf-surface"
import { SplitPane } from "./split-pane"
import type { Finding, FindingId } from "../data/review-data"

export interface SideBySideProps {
  fplUrl: string
  masterUrl: string
  fplLabel: string
  masterLabel: string
  page: number
  zoom: number
  findings: Finding[]
  activeFindingId: FindingId | null
  onSelectFinding: (id: FindingId) => void
}

export function SideBySide({
  fplUrl,
  masterUrl,
  fplLabel,
  masterLabel,
  page,
  zoom,
  findings,
  activeFindingId,
  onSelectFinding,
}: SideBySideProps): JSX.Element {
  return (
    <SplitPane
      storageKey="review:side-by-side"
      defaultFraction={0.5}
      minFraction={0.3}
      maxFraction={0.7}
      ariaLabel="Resize compare panes"
      left={
        <PdfSurface
          documentUrl={fplUrl}
          label={fplLabel}
          subtitle="Final Printed Label"
          page={page}
          zoom={zoom}
          findings={findings}
          activeFindingId={activeFindingId}
          onSelectFinding={onSelectFinding}
        />
      }
      right={
        <PdfSurface
          documentUrl={masterUrl}
          label={masterLabel}
          subtitle="Approved master"
          page={page}
          zoom={zoom}
          findings={[]}
          activeFindingId={null}
          onSelectFinding={() => undefined}
        />
      }
    />
  )
}
